import { render, staticRenderFns } from "./VTaxEntitySelector.vue?vue&type=template&id=2ef61b4a"
import script from "./VTaxEntitySelector.vue?vue&type=script&lang=ts"
export * from "./VTaxEntitySelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports